import $ from 'jquery';

const wrapper = $('.header_main__search'),
	form = wrapper.find('form'),
	icon = wrapper.find('.header_main__search-input_icon');

$(icon).on('click', function (e) {
	form.submit();
});
